import { typeDashboardContentChartTypes } from './dashboard-content-items.models';

export const DashboardDataServiceActionsValues = {
    addChart: "addChart"
} as const;
export type typeDashboardDataServiceActions = typeof DashboardDataServiceActionsValues[keyof typeof DashboardDataServiceActionsValues];

export interface DashboardDataServiceActions {
    actionType: typeDashboardDataServiceActions,
    content: any,
    widgetType: typeDashboardContentChartTypes
}
